import Client from 'shopify-buy';

const accessToken = 'b66b40f3581b500e75bc15e11fd90377';
const domain = 'bw-restaurants-oy';
const appId = '7247626267';

export const shopClient = Client.buildClient({
  accessToken: accessToken,
  domain: domain+'.myshopify.com',
  appId: appId
});

export const getProductsInCollection = (collection) =>
  shopClient.fetchQueryProducts({ collection_id: collection })
  .then(response => response)
  .catch(function () {
    console.log('Request failed');
  });


// WEBPACK FOOTER //
// ./src/api/shopifyAPI.js